/*
 *
 * DynamicScoreReports constants
 *
 */
import AptitudeIcon from "resources/images/dynamic_score_reports/aptitude/score-range-icons/custom-sr-aptitude.png";
import SkillsIcon from "resources/images/dynamic_score_reports/skills/score-range-icons/custom-sr-skills.png";
import EmotionalIntelligenceIcon from "resources/images/dynamic_score_reports/emotional/score-range-icons/custom-sr-emotional-intelligence.png";
import PersonalityIcon from "resources/images/dynamic_score_reports/personality/score-range-icons/custom-sr-personality.png";
import RiskIcon from "resources/images/dynamic_score_reports/risk/score-range-icons/custom-sr-risk.png";
import TestMakerIcon from "resources/images/dynamic_score_reports/testmaker/score-range-icons/custom-sr-testmaker.png";
import robotInspectorIcon from "resources/images/dynamic_score_reports/aptitude/score-report/robot-inspector-icon.png";
import weighStationIcon from "resources/images/dynamic_score_reports/aptitude/score-report/weigh-station-icon.png";
import birdOnCableIcon from "resources/images/dynamic_score_reports/aptitude/score-report/words-feather-icon.png";
import emotionalManagingIcon from "resources/images/dynamic_score_reports/emotional/score-report/managing-icon.png";
import emotionalPerceivingIcon from "resources/images/dynamic_score_reports/emotional/score-report/perceiving-icon.png";
import emotionalUnderstandingIcon from "resources/images/dynamic_score_reports/emotional/score-report/understanding-icon.png";
import aptitudeAttentionIcon from "resources/images/dynamic_score_reports/aptitude/score-report/attention-icon.png";
import aptitudeMemoryIcon from "resources/images/dynamic_score_reports/aptitude/score-report/memory-icon.png";
import aptitudeReasoningIcon from "resources/images/dynamic_score_reports/aptitude/score-report/reasoning-icon.png";
import aptitudeDividedAttentionIcon from "resources/images/dynamic_score_reports/aptitude/score-report/divided-attention-icon.png";
import aptitudeVigilanceIcon from "resources/images/dynamic_score_reports/aptitude/score-report/vigilance-icon.png";
import aptitudeFilteringIcon from "resources/images/dynamic_score_reports/aptitude/score-report/filtering-icon.png";
import aptitudeSpatialIcon from "resources/images/dynamic_score_reports/aptitude/score-report/aptitude-score-report-spatial-icon.png";
import aptitudeVerbalIcon from "resources/images/dynamic_score_reports/aptitude/score-report/aptitude-score-report-verbal-icon.png";
import aptitudeMathIcon from "resources/images/dynamic_score_reports/aptitude/score-report/aptitude-score-report-math-icon.png";
import aptitudeDetailIcon from "resources/images/dynamic_score_reports/aptitude/score-report/aptitude-score-report-attention-to-detail-icon.png";
import skillsVerbalIcon from "resources/images/dynamic_score_reports/skills/score-report/math-and-logic.png";
import skillsMathIcon from "resources/images/dynamic_score_reports/skills/score-report/verbal-ability.png";
import skillsReadingIcon from "resources/images/dynamic_score_reports/skills/score-report/reading.png";
import skillsWritingIcon from "resources/images/dynamic_score_reports/skills/score-report/writing.png";
import skillsListeningIcon from "resources/images/dynamic_score_reports/skills/score-report/listening.png";
import VideoAssessmentIcon from "resources/images/video-assessment-icon.png";
import DSRSIUpgrade4Icon from "resources/images/dsr-si-upgrade-4-icon.svg";
import DSRDevelopUpgrade1Icon from "resources/images/dsr-develop-upgrade-1-icon.svg";
import DSRDevelopUpgrade2Icon from "resources/images/dsr-develop-upgrade-2-icon.svg";

// All currently supported tests - adding a new test requires adding its testId here.
export const supportedTests = [
  10, 12, 13, 14, 15, 16, 17, 18, 21, 22, 23, 24, 30, 31, 32, 33, 34, 35, 36,
  37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 48, 49, 50, 51, 52, 53, 54, 55, 57,59
];

export const testInfoDescriptions = {
  10: `The CCAT measures cognitive aptitude, or general intelligence. This test provides an indication of a subject's ability to solve problems, digest and apply information, learn new skills, and think critically. Cognitive aptitude is one of the most accurate job predictors of job success for any position.`,
  12: `The CBST measures the basic math and verbal skills that are required to succeed in a variety of entry-level jobs, such as grammar, spelling, math, and language skills. It offers a quick way to assess the job readiness of candidates in a range of jobs, including clerical, administrative, and customer service.`,
  13: `The CPI is a personality assessment based on the most widely accepted system for classifying personality: the "Big Five" personality traits. Scores for each scale are expressed as percentile rankings, and reflect how each test-taker rates for a given trait, compared to all other test-takers. As with other personality tests, there are no "high" or "low" scores on the CPI; rather, people with certain traits will tend to perform better in certain jobs.`,
  14: `The MRAB is a nine-test battery that measures key information processing functions (attention, working memory, and reasoning) representative of a person's "mental fitness." The MRAB is ideal for a small subset of jobs that require a great deal of sustained, long-term focus.`,
  15: `The CSAP measures personality traits related to customer service potential and performance, such as diplomacy, cooperativeness and patience.`,
  16: `The WTMA measures a subject's mechanical aptitude. The test can predict performance for occupations that involve the operation, maintenance, and servicing of tools, equipment and machinery.`,
  17: `The Typing Test measures the speed and accuracy at which an individual can type. The test-taker is presented with a passage and given one minute to type as much of the passage as possible. Their score reflects the number of words per minute (WPM) that they typed, and the adjusted score reflects the number of words they typed correctly.`,
  18: `The Ten Key Test measures an individual's ability to perform data entry for numerical fields. The test provides a speed score (keystrokes per hour), a percentile ranking for the speed score, and an accuracy score (number of correct entries, out of a possible 20).`,
  21: `The Microsoft Excel 2007 (Multiple Choice) test measures proficiency with a wide range of functionalities in Excel 2007. The test is 10 minutes and contains 20 questions.`,
  22: `The Microsoft Word 2007 (Multiple Choice) test measures proficiency with a wide range of functionalities in Word 2007. The test is 10 minutes and contains 20 questions.`,
  23: `The CAST is a short test that measures attention and concentration. Because it measures the ability to sustain focus and maintain concentration, the CAST can help predict employee success in a wide variety of positions, including drivers, pilots, skilled manufacturing jobs, gaming dealers, and video surveillance workers.`,
  24: `Measures personality traits critical to success in sales and related fields. It assesses traits that are not apparent in an interview or resume, such as inhibitions about cold calling, reluctance to ask for a sale, and motivation to follow through.`,
  30: `The CLIK is an assessment of basic computer proficiency. It measures a person's ability to use Internet browsers and common desktop applications such as email and word processing programs.`,
  31: `The WPP is a risk assessment that is used to predict whether an applicant will be a conscientious, productive, and reliable employee. It measures traits relating to work habits, integrity, and perceived risk of engaging in counterproductive work behaviors such as theft.`,
  32: `The Microsoft Excel 2010 (Multiple Choice) test measures proficiency with a wide range of functionalities in Excel 2010. The test is 10 minutes and contains 20 questions.`,
  33: `The Microsoft Word 2010 (Multiple Choice) test measures proficiency with a wide range of functionalities in Word 2010. The test is 10 minutes and contains 20 questions.`,
  34: `The EPP is a personality assessment that measures twelve traits. Scores for each trait are expressed as a percentile ranking, which reflects how a person scored on that trait relative to other test-takers. There are no "high" or "low" scores on the EPP; rather, people with certain traits tend to be a better fit for certain jobs. The EPP contains a series of job-family benchmarks that assess how good a fit a person's personality is for a given position.`,
  35: `The Microsoft Excel 2013 (Multiple Choice) test measures proficiency with a wide range of functionalities in Excel 2013. The test is 10 minutes and contains 20 questions.`,
  36: `The Microsoft Word 2013 (Multiple Choice) test measures proficiency with a wide range of functionalities in Word 2013. The test is 10 minutes and contains 20 questions.`,
  37: `The UCAT measures cognitive aptitude, or general intelligence. This test provides an indication of a subject's ability to solve problems, digest and apply information, learn new skills, and think critically. Cognitive aptitude is one of the most accurate predictors of job success for any position.`,
  38: `The Microsoft PowerPoint 2013 (Multiple Choice) test measures proficiency with a wide range of functionalities in PowerPoint 2013. The test is 10 minutes and contains 20 questions.`,
  39: `The Microsoft Excel 2016 (Multiple Choice) test measures proficiency with a wide range of functionalities in Excel 2016. The test is 10 minutes and contains 20 questions.`,
  40: `The Microsoft Word 2016 (Multiple Choice) test measures proficiency with a wide range of functionalities in Word 2016. The test is 10 minutes and contains 20 questions.`,
  41: `The Microsoft PowerPoint 2016 (Multiple Choice) test measures proficiency with a wide range of functionalities in PowerPoint 2016. The test is 10 minutes and contains 20 questions.`,
  42: `GAME provides your candidates with a brand positive, mobile, anywhere, anytime test of their abilities. People who score better on GAME are more likely to excel at solving problems, understanding and applying information, learning new skills, and thinking critically.`,
  43: `The CMRA measures a subject's mechanical aptitude. The test can predict performance for occupations that involve the operation, maintenance, and servicing of tools, equipment and machinery.`,
  44: `Emotify is an ability-based measure of emotional intelligence, measuring a candidate's ability to accurately identify and understand emotions. Research has shown that emotional intelligence is associated with important work related outcomes such as interpersonal effectiveness, collaboration and team work, decision making and success in leadership and management roles.`,
  45: `Cognify is a game based assessment of cognitive aptitude that predicts employee performance at work. Candidates who score well on Cognify are likely to problem solve effectively, work well with numbers, process information quickly and accurately, and demonstrate strong reading and writing skills.`,
  46: `The Work Safety Assessment measures a candidate's attitudes towards safety, which provides insight into the likely behaviors they will display in the workplace. Their results provide a reliable indication of the likelihood that they will be involved in accidents or cause injury to themselves or others while at work.`,
  48: `Illustrait provides insights into an individual's competency potential in areas of specific relevance to a particular role. This information can be used in areas such as: recruitment and selection, development and coaching, and promotion decisions.`,
  49: `The CLIK is an assessment of basic computer proficiency. It measures a person's ability to use Internet browsers and common desktop applications such as email and word processing programs.`,
  50: `The Workplace Alignment Assessment measures the degree of alignment between a candidate's work-related preferences and the environment provided by the organization. Candidates are more likely to be committed to their employer and put in extra effort during their time at work when their most valued needs and preferences are emphasized by the organization.`,
  51: `Emotify is an ability-based measure of emotional intelligence, measuring a candidate's ability to accurately identify, understand, and manage emotions. Research has shown that emotional intelligence is associated with important work related outcomes such as interpersonal effectiveness, collaboration, team work, decision making and success in leadership and management roles.`,
  52: `UCognify is a universal game based assessment of cognitive aptitude that predicts employee performance at work. Candidates who score well on UCognify are likely to problem solve effectively, work well with numbers, and process information quickly and accurately.`,
  53: `The Microsoft Excel 365 test measures proficiency with a wide range of functionalities in Excel 365, from beginner to advanced level.`,
  54: `The Microsoft Word 365 test measures proficiency with a wide range of functionalities in Word 365, from beginner to advanced level.`,
  55: `The Microsoft PowerPoint 365 test measures proficiency with a wide range of functionalities in PowerPoint 365, from beginner to advanced level.`,
  57: `The CLPT - English measures proficiency in the English language in one or more of the following skill components: reading, writing, and listening. The test measures proficiency from beginner to advanced levels.`,
  59: `The CTRS Express measures cognitive aptitude, or general intelligence, across a variety of domains. This test provides an indication of a candidate’s ability to process and use different types of information to solve problems. Cognitive aptitude is one of the most accurate predictors of job success for any position.`
};

export const testsWithScoreRangeSections = [
  10, 12, 16, 21, 22, 32, 33, 35, 36, 37, 38, 39, 40, 41, 42, 43, 48, 53, 54,
  55, 57, 59
];

export const testDetails = {
  10: {
    scoreBoxTraits: ["rawScore", "percentile"],
    subcategories: ["spatialPercentile", "verbalPercentile", "mathPercentile"], // this array determines the order that the details appear
    subcategoryConstants: {
      spatialPercentile: {
        description:
          "Ability to visualize, make spatial judgements, and problem solve; correlated to general intelligence.",
        imgPath: aptitudeSpatialIcon,
      },
      verbalPercentile: {
        description:
          "Reasoning and comprehension of words, constructive thinking, and attention to detail.",
        imgPath: aptitudeVerbalIcon,
      },
      mathPercentile: {
        description:
          "Ability to reason using numbers and numerical concepts.  Also measures logic and analytical thinking.",
        imgPath: aptitudeMathIcon,
      },
    },
  },
  12: {
    subcategories: ["verbalCorrect", "mathCorrect"],
    subcategoryConstants: {
      verbalCorrect: {
        description:
          "Competency in basic verbal skills, including reading comprehension, grammar, attention to detail, spelling, and punctuation.",
        imgPath: skillsVerbalIcon,
      },
      mathCorrect: {
        description:
          "Competency in basic quantitative skills, including arithmetic and numerical problem-solving.",
        imgPath: skillsMathIcon,
      },
    },
  },
  14: {
    subcategories: ["ATT", "MEM", "REA"],
    subcategoryConstants: {
      ATT: {
        description:
          "An indication of the ability to focus and maintain concentration on one or more tasks.",
        imgPath: aptitudeAttentionIcon,
      },
      MEM: {
        description:
          'Measures the ability to remember, or "hold in mind" information.',
        imgPath: aptitudeMemoryIcon,
      },
      REA: {
        description:
          "Provides an indication of critical thinking, reasoning, and problem solving ability.",
        imgPath: aptitudeReasoningIcon,
      },
    },
  },
  15: {
    subcategories: ["INC_score", "CRT_adjPercentile", "ENH_adjPercentile"],
  },
  23: {
    subcategories: ["DA", "VIG", "FIL"],
    subcategoryConstants: {
      DA: {
        description:
          'Measures the ability to "multi-task" or concentrate on two or more things simultaneously.',
        imgPath: aptitudeDividedAttentionIcon,
      },
      VIG: {
        description:
          "Measures the ability to maintain concentration on a task for a sustained period of time.",
        imgPath: aptitudeVigilanceIcon,
      },
      FIL: {
        description:
          "Measures the ability to focus on important information and ignore irrelevant distractions.",
        imgPath: aptitudeFilteringIcon,
      },
    },
  },
  24: {
    subcategories: ["INC_score", "CRT_adjPercentile", "ENH_adjPercentile"],
  },
  31: { subcategories: ["FAKING_percentile"] },
  34: {
    scoreBoxTraits: ["EPPPositionMatch"],
    subcategories: ["INC_score", "ENH_adjPercentile", "CRT_adjPercentile"],
  },
  37: {
    subcategories: [
      "logicPercentile",
      "mathPercentile",
      "detailPercentile",
      "spatialPercentile",
    ],
    subcategoryConstants: {
      spatialPercentile: {
        description:
          "Ability to visualize, make spatial judgments, and problem solve.",
        imgPath: aptitudeSpatialIcon,
      },
      logicPercentile: {
        description:
          "Ability to use logic and reasoning to solve problems and interpret data.",
        imgPath: aptitudeVerbalIcon,
      },
      mathPercentile: {
        description: "Ability to reason using numbers and numerical concepts.",
        imgPath: aptitudeMathIcon,
      },
      detailPercentile: {
        description:
          "Ability to focus on detail-oriented tasks with thoroughness and accuracy.",
        imgPath: aptitudeDetailIcon,
      },
    },
  },
  42: {
    subcategories: ["detailPercentile", "verbalPercentile", "mathPercentile"],
    subcategoryConstants: {
      detailPercentile: {
        description:
          "The game <em>Robot Inspector</em> measures the ability to focus on detail-oriented tasks with thoroughness and accuracy.",
        imgPath: robotInspectorIcon,
      },
      verbalPercentile: {
        description: `The game <em>Words of a Feather</em> measures verbal reasoning, which dictates communication skills and comprehension.`,
        imgPath: birdOnCableIcon,
      },
      mathPercentile: {
        description: `The game <em>Weigh Station</em> measures numeracy, quantitative problem-solving, and number fluency.`,
        imgPath: weighStationIcon,
      },
      hasRichText: true,
    },
  },
  44: {
    subcategories: ["perceivingPercentile", "understandPercentile"],
    subcategoryConstants: {
      perceivingPercentile: {
        description:
          "This candidate completed an assessment called Matching Faces, which measured their ability to quickly and accurately identify a broad range of emotions in facial expressions. Individuals who are able to accurately perceive emotions are more likely to identify a need to respond and adapt to people and situations as required.",
        imgPath: emotionalPerceivingIcon,
      },
      understandPercentile: {
        description:
          "This candidate completed an assessment called Emotional Ties, which assessed their ability to recognize emotions and demonstrate awareness of how different situations and events influence emotions. Individuals with a strong understanding of emotions are better able to predict future emotions based on current events and use this knowledge to inform their approach to people and situations.",
        imgPath: emotionalUnderstandingIcon,
      },
    },
  },
  45: {
    subcategories: [
      "problemSolvingPercentile",
      "numericalReasoningPercentile",
      "verbalKnowledgePercentile",
    ],
    subcategoryConstants: {
      problemSolvingPercentile: {
        description: {
          "3game":
            "<em>Grid Lock</em> measures Problem Solving abilities such as reasoning, evaluating and learning under pressure. This ability influences capacity to learn quickly on the job and succeed in a role.",
          "6game":
            "<em>Short Cuts</em>, <em>Grid Lock</em>, and <em>Resemble</em>, measure Problem Solving abilities such as reasoning, evaluating and learning under pressure. This ability influences capacity to learn quickly on the job and succeed in a role.",
        },
        imgPath: aptitudeSpatialIcon,
      },
      numericalReasoningPercentile: {
        description: {
          "3game":
            "<em>Numbubbles</em> measures Numerical Reasoning abilities such as solving mathematical problems under time pressure. This ability is important where working with numbers is critical.",
          "6game":
            "<em>Numbubbles</em> and <em>Tally Up</em> measure Numerical Reasoning abilities such as solving mathematical problems under time pressure. This ability is important where working with numbers is critical.",
        },
        imgPath: aptitudeMathIcon,
      },
      verbalKnowledgePercentile: {
        description: {
          "3game": `<em>Proof It</em> measures Verbal abilities such as identifying misspelled words and punctuation errors. These abilities are important for roles where reading and writing are required for day-to-day tasks.`,
          "6game": `<em>Proof It</em> measures Verbal abilities such as identifying misspelled words and punctuation errors. These abilities are important for roles where reading and writing are required for day-to-day tasks.`,
        },
        imgPath: aptitudeVerbalIcon,
      },
      hasRichText: true,
    },
  },
  46: {
    subcategories: ["validityINC", "validityENH"],
  },
  51: {
    subcategories: [
      "perceivingPercentile",
      "understandPercentile",
      "managingPercentile",
    ],
    subcategoryConstants: {
      perceivingPercentile: {
        description:
          "This candidate completed an assessment called Matching Faces, which measured their ability to quickly and accurately identify a broad range of emotions in facial expressions. Individuals who are able to accurately perceive emotions are more likely to identify a need to respond and adapt to people and situations as required.",
        imgPath: emotionalPerceivingIcon,
      },
      understandPercentile: {
        description:
          "This candidate completed an assessment called Emotional Ties, which assessed their ability to recognize emotions and demonstrate awareness of how different situations and events influence emotions. Individuals with a strong understanding of emotions are better able to predict future emotions based on current events and use this knowledge to inform their approach to people and situations.",
        imgPath: emotionalUnderstandingIcon,
      },
      managingPercentile: {
        description: `This candidate completed an assessment called Emotions in Action, which measured their capacity to effectively manage emotions. Individuals with strong emotion management skills are better able to manage their own and others' emotions to help achieve a desired outcome, and influence emotions in ways that are more likely to be helpful to a situation rather than harmful.`,
        imgPath: emotionalManagingIcon,
      },
    },
  },
  52: {
    subcategories: ["problemSolvingPercentile", "numericalReasoningPercentile"],
    subcategoryConstants: {
      problemSolvingPercentile: {
        description: {
          "2game":
            "<em>Grid Lock</em> measures Problem Solving abilities such as reasoning, evaluating and learning under pressure. This ability influences capacity to learn quickly on the job and succeed in a role.",
          "5game":
            "<em>Short Cuts</em>, <em>Grid Lock</em>, and <em>Resemble</em>, measure Problem Solving abilities such as reasoning, evaluating and learning under pressure. These abilities influence the capacity to learn quickly on the job and succeed in a role.",
        },
        imgPath: aptitudeSpatialIcon,
      },
      numericalReasoningPercentile: {
        description: {
          "2game":
            "<em>Numbubbles</em> measures Numerical Reasoning abilities such as solving mathematical problems under time pressure. This ability is important where working with numbers is critical.",
          "5game":
            "<em>Numbubbles</em> and <em>Tally Up</em> measure Numerical Reasoning abilities such as solving mathematical problems under time pressure. These abilities are important where working with numbers is critical.",
        },
        imgPath: aptitudeMathIcon,
      },
      hasRichText: true,
    },
  },
  57: {
    subcategories: ["readingScore", "listeningScore", "writingScore"],
    subcategoryConstants: {
      readingScore: {
        description:
          "This module measures the ability to read, comprehend, and extract information from various types of formal and informal text, including conversations, emails, announcements, and factual paragraphs.",
        imgPath: skillsReadingIcon,
      },
      listeningScore: {
        description:
          "This module measures the ability to listen, comprehend, and extract information from various types of formal and informal auditory stimuli, including conversations, instructions, announcements, and factual paragraphs.",
        imgPath: skillsListeningIcon,
      },
      writingScore: {
        description:
          "This module measures the ability to produce written descriptions of images, responses to everyday questions, and responses to dialogue of both formal and informal nature.",
        imgPath: skillsWritingIcon,
      },
    },
  },
};

export const dynamicTraitFieldToPretty = {
  10: {
    rawScore: "Raw Score",
    percentile: "Percentile",
    spatialPercentile: "Spatial Reasoning Percentile",
    verbalPercentile: "Verbal Ability Percentile",
    mathPercentile: "Math and Logic Percentile",
  },
  12: {
    verbalCorrect: "Verbal Raw Score",
    mathCorrect: "Math Raw Score",
  },
  14: {
    ATT: "Attention Percentile",
    MEM: "Memory Percentile",
    REA: "Reasoning Percentile",
  },
  15: {
    INC_score: "Inconsistent Responding (INC)",
    ENH_adjPercentile: "Self-Enhancing Score (ENH)",
    CRT_adjPercentile: "Self-Critical Score (CRT)",
    cs: "Customer Service and Inside Sales Characteristics",
    motivation: "Motivation and Achievement Characteristics",
    interpersonal: "Interpersonal Strengths",
    sales: "Sales Success Characteristics",
    work: "Work Strengths",
    inner: "Inner Resources",
  },
  23: {
    DA: "Divided Attention Percentile",
    VIG: "Selective Attention: Vigilance Percentile",
    FIL: "Selective Attention: Filtering Percentile",
  },
  24: {
    INC_score: "Inconsistent Responding (INC)",
    ENH_adjPercentile: "Self-Enhancing Score (ENH)",
    CRT_adjPercentile: "Self-Critical Score (CRT)",
    sales: "Sales Related Characteristics",
    work: "Work Strengths",
    inner: "Inner Resources",
    motivation: "Motivation and Achievement Characteristics",
    interpersonal: "Interpersonal Strengths",
  },
  31: {
    FAKING_percentile: "Self-Enhancing Score (ENH)",
  },
  34: {
    AccountingFinance: "Accounting / Finance",
    AdministrativeAssistant: "Administrative Assistant",
    Analyst: "Analyst",
    BankTeller: "Bank Teller",
    Collections: "Collections",
    CustomerService: "Customer Service",
    FrontDeskReception: "Front Desk / Reception",
    Manager: "Manager",
    MedicalAssistant: "Medical Assistant",
    ProductionManufacturing: "Production / Manufacturing",
    ProgrammerDeveloper: "Programmer / Developer",
    Sales: "Sales",
    INC_score: "Inconsistent Responding (INC)",
    ENH_adjPercentile: "Self-Enhancing Score (ENH)",
    CRT_adjPercentile: "Self-Critical Score (CRT)",
  },
  37: {
    logicPercentile: "Logic & Analysis Percentile",
    mathPercentile: "Numerical Reasoning Percentile",
    detailPercentile: "Attention to Detail Percentile",
    spatialPercentile: "Spatial Reasoning Percentile",
  },
  42: {
    detailPercentile: "Attention to Detail Percentile",
    verbalPercentile: "Verbal Ability Percentile",
    mathPercentile: "Numerical Reasoning Percentile",
  },
  44: {
    perceivingPercentile: "Perceiving Emotions Percentile",
    understandPercentile: "Understanding Emotions Percentile",
  },
  45: {
    problemSolvingPercentile: "Problem Solving Percentile",
    numericalReasoningPercentile: "Numerical Reasoning Percentile",
    verbalKnowledgePercentile: "Verbal Knowledge Percentile",
  },
  46: {
    validityINC: "Inconsistent Responding (INC)",
    validityENH: "Self-Enhancing Score (ENH)",
  },
  51: {
    perceivingPercentile: "Perceiving Emotions Percentile",
    understandPercentile: "Understanding Emotions Percentile",
    managingPercentile: "Managing Emotions Percentile",
  },
  52: {
    problemSolvingPercentile: "Problem Solving Percentile",
    numericalReasoningPercentile: "Numerical Reasoning Percentile",
  },
  57: {
    readingScore: "Reading Score",
    writingScore: "Writing Score",
    listeningScore: "Listening Score",
    readingCEFR: "Reading Level",
    writingCEFR: "Writing Level",
    listeningCEFR: "Listening Level",
  },
};

export const cognify3GameSubTestIds = [121, 123, 163];
export const ucognify2GameSubTestIds = [
  138, 140, 141, 143, 145, 150, 153, 159, 161, 166, 169, 173,
];

export const workplaceInsightsTraitMap = {
  // array format: [name, description, color]
  1: [
    "Goal-Oriented",
    "Values achievement, sets goals, and prioritizes achieving them",
    "#425CC7",
  ],
  2: [
    "Conscientious",
    "Tends to be dependable, organized and self-disciplined",
    "#425CC7",
  ],
  3: ["Motivated", "Likely seen by others as committed and driven", "#425CC7"],
  "4a": [
    "Assertive",
    "Bold, forceful and sometimes dominant presence; not inclined to defer",
    "#ffa300",
  ],
  "4b": [
    "Accommodating",
    "Accommodating and often deferential to others in group settings",
    "#ffa300",
  ],
  "4c": [
    "Moderately Assertive",
    "Generally comfortable either taking the lead or following others in work settings",
    "#ffa300",
  ],
  "5a": [
    "Cooperative",
    "Values social harmony, inclined to seek common ground",
    "#ffa300",
  ],
  "5b": [
    "Independent, Aggressive",
    "Often committed to own views; tends to take the lead in work situations",
    "#ffa300",
  ],
  "6a": [
    "Extroverted",
    "Socially outgoing, gregarious, often initiates social interactions",
    "#ffa300",
  ],
  "6b": [
    "Introverted",
    `Reserved and low-key; best in roles that don't involve constant social interaction`,
    "#ffa300",
  ],
  "6c": [
    "Ambiverted",
    "Neither introverted or extroverted; generally comfortable in social situations",
    "#ffa300",
  ],
  7: [
    "Competitive",
    "Innate drive to win, measures performance in comparison to others",
    "#FF5C39",
  ],
  "8a": [
    "Intellectually Curious",
    "Creative and unafraid of experimentation, interested in learning and exploration",
    "#2dccd3",
  ],
  "8b": [
    "Conventional",
    "Favors routine over experimentation; prefers the familiar to the novel",
    "#2dccd3",
  ],
  "8c": [
    "Moderate Openness to Experience",
    "Often conventional but open to variety and exploration",
    "#2dccd3",
  ],
  "9a": [
    "Patient",
    "Accepting and tolerant of delays or challenges",
    "#FF5C39",
  ],
  "9b": [
    "Impatient",
    "Will tend to feel urgency or react quickly when encountering obstacles",
    "#FF5C39",
  ],
  "9c": [
    "Moderately Patient",
    "Generally copes effectively with frustrations when completing tasks",
    "#FF5C39",
  ],
  10: ["Self-Confident", "Self-assured and secure", "#2dccd3"],
};

export const testTypeScoreRangeIconMap = {
  aptitude: AptitudeIcon,
  skills: SkillsIcon,
  emotional: EmotionalIntelligenceIcon,
  emotionalIntelligence: EmotionalIntelligenceIcon,
  personality: PersonalityIcon,
  risk: RiskIcon,
  testMaker: TestMakerIcon,
};

export const CPILowAndHighBarText = {
  AGR: {
    lowPole: "Single-minded,\nUnyielding",
    highPole: "Accommodating,\nFlexible",
  },
  CON: {
    lowPole: "Spontaneous,\nLaid-back",
    highPole: "Dependable,\nSelf-Disciplined",
  },
  EXT: {
    lowPole: "Introverted,\nLow-Key",
    highPole: "Extroverted,\nSociable",
  },
  OPE: {
    lowPole: "Conventional,\nTraditional",
    highPole: "Experimental,\nCreative",
  },
  STR: {
    lowPole: "Excitable",
    highPole: "Calm,\nEven Tempered",
  },
};

export const wppScoreTextMap = {
  LOW: "lowText",
  MEDIUM: "medText",
  HIGH: "highText",
};

export const officeProficiencyDescriptions = {
  53: {
    Beginner: [
      "Navigating files (e.g. opening & saving Excel files)",
      "Formatting cells (e.g. font, cell alignment)",
      `Formula basics (e.g. using '=' to start a formula, basic cell referencing)`,
      "Cell navigation and selection (e.g. selecting cells, rows, and columns)",
    ],
    Foundational: [
      "Basic commands (e.g. cut, copy, paste)",
      "Fill data automatically in cells (i.e. AutoFill)",
      "Basic functions (e.g. SUM, AVERAGE, COUNT)",
      "Changing data types (i.e. Number formatting)",
      "Modifying worksheets (e.g. resizing, hiding, or deleting rows and columns)",
    ],
    Intermediate: [
      "Sorting and filtering data",
      "Troubleshooting errors (e.g. #NUM!, #SPILL!)",
      "Format painter",
      "Creating and editing charts",
      "Text to columns",
    ],
    Skilled: [
      "Skilled functions (e.g. SUMIF, COUNTIF, SUMPRODUCT)",
      "Array formulas",
      "Nested functions (e.g. IF and AND)",
      "Absolute, relative and mixed cell referencing",
      "Workbook security (e.g. Encrypting Workbook with password)",
    ],
    Advanced: [
      "Advanced functions (e.g. LOOKUP functions)",
      "Macros and VBA",
      "PivotTables",
      "Data validation",
      "Logical operators and wildcards",
    ],
  },
  54: {
    Beginner: [
      "Create, close, save, and print documents",
      "Cut, copy, and paste text",
      "Fonts (e.g. bold, underline)",
      "Basic editing (e.g. spelling and grammar, undo and redo)",
      "Inserting numbered and bulleted lists",
    ],
    Foundational: [
      "Formatting (e.g. page numbers, indenting paragraphs, line spacing, margins)",
      "Tables (e.g. inserting or deleting rows and columns, aligning text in cells)",
      "Shapes (e.g. inserting, grouping, formatting)",
      "Pictures (e.g. inserting, cropping, rotating)",
      "Document protection (e.g. passwords, read-only format)",
    ],
    Intermediate: [
      "Templates",
      "Themes",
      "Referencing (e.g. footnotes, citations)",
      "Page and section breaks",
      "SmartArt",
      "Advanced editing (e.g. format painter, find and replace)",
    ],
    Skilled: [
      "Headers and footers",
      "Styles",
      "Table of contents (e.g. inserting, formatting)",
      "Language and dictionary (e.g. translating text, default languages)",
      "Track changes",
      "Document protection (e.g. passwords, read-only format)",
    ],
    Advanced: [
      "Mail merge",
      "Fields (e.g. insert fields, field codes)",
      "Bookmarks",
      "Master documents (e.g. creating and merging subdocuments)",
      "Macros and VBA",
      "Building Blocks",
    ],
  },
  55: {
    Beginner: [
      "Basic navigation (e.g. opening, closing, new slides)",
      "WordArt",
      "Common keyboard shortcuts",
      "Basic slide features (e.g. backgrounds, slide notes)",
    ],
    Foundational: [
      "Working with images (e.g. inserting, cropping)",
      "Basic shapes (e.g. inserting, formatting)",
      "Basic charts (e.g. inserting, chart types)",
      "Working with text",
      "Printing slides",
      "Formatting objects",
    ],
    Intermediate: [
      "Creating and using Templates",
      "SmartArt",
      "Advanced shapes (e.g. grouping, merging)",
      "Slide transitions",
      "Basic presenting (e.g. Presenter View)",
    ],
    Skilled: [
      "Creating and using Themes",
      "Slide Master",
      "Applying and using animations",
      "Advanced presenting (e.g. self running presentations)",
    ],
    Advanced: [
      "Working with media (e.g. inserting videos)",
      "Working with tables and data",
      "Advanced slide features (e.g. sections, locking)",
      "Advanced chart features (e.g. linking to Excel)",
    ],
  },
};

export const DSRMerchandisingSectionText = {
  "dsr-si-upgrade-1": {
    icon: VideoAssessmentIcon,
    title: "Upgrade Your Interview Process",
    description: `Ready to screen your candidates 75% faster? It’s like watching a movie trailer preview, but of your candidates.`,
  },
  "dsr-si-upgrade-2": {
    icon: VideoAssessmentIcon,
    title: "Upgrade Your Interview Process",
    description:
      "Create structured interviews in less time than it takes to make your morning coffee. Select from a library of interview questions or set up your own unique template in minutes.",
  },
  "dsr-si-upgrade-3": {
    icon: VideoAssessmentIcon,
    title: "Upgrade Your Interview Process",
    description:
      "Hate dealing with candidate interview no-shows? Limit their impact by utilizing this asynchronous Video Interviewing tool.",
  },
  "dsr-si-upgrade-4": {
    icon: DSRSIUpgrade4Icon,
    title: "Better Interviews for Everyone",
    description: `Make interviews a positive experience for everyone. From hiring managers to candidates, Criteria’s structured interviewing tools ensure a faster, fairer experience that results in better hires.`,
  },
  "dsr-develop-upgrade-1": {
    icon: DSRDevelopUpgrade1Icon,
    title: `Don't Just Hire Great Talent. Develop It.`,
    description: `Love hiring with science and data? Use the same approach to empower your existing workforce with Develop.`,
  },
  "dsr-develop-upgrade-2": {
    icon: DSRDevelopUpgrade2Icon,
    title: `Don't Just Hire Great Talent. Develop It.`,
    description:
      "Empower your managers to become superstars with 24/7, AI-based coaching and insights in Develop, custom-built for your team, and your team only.",
  },
  "dsr-develop-upgrade-3": {
    icon: DSRDevelopUpgrade2Icon,
    title: `Don't Just Hire Great Talent. Develop It.`,
    description:
      "Bye bye, manager overwhelm. Hello happy, high-performing teams. This talent management tool will empower managers and maximize team results.",
  },
  "dsr-develop-upgrade-4": {
    icon: DSRDevelopUpgrade2Icon,
    title: "Ready to unlock team happiness + high performance?",
    description: `Develop™ by Criteria is the only solution that equips managers with the targeted insights, AI-powered coaching, and hard-wired habits that turn them into super leaders.`,
  },
  "dsr-si-upgrade-5": {
    icon: DSRDevelopUpgrade2Icon,
    title: "Hire 3x Faster with Video Interviews, now Supercharged with AI",
    description: `Make every interview 2x more predictive, up to 3x faster, and better for 70% of candidates. Plus, with AI-powered Interview Intelligence, you can shortlist in seconds, not hours. Ready to reclaim your time?`,
  },
  "dsr-si-adopt-1": {
    icon: VideoAssessmentIcon,
    title: "Upgrade Your Interview Process",
    description: `Ready to screen your candidates 75% faster? It’s like watching a movie trailer preview, but of your candidates.`,
  },
  "dsr-si-adopt-2": {
    icon: VideoAssessmentIcon,
    title: "Upgrade Your Interview Process",
    description:
      "Create structured interviews in less time than it takes to make your morning coffee. Select from a library of interview questions or set up your own unique template in minutes.",
  },
  "dsr-si-adoption-3": {
    icon: VideoAssessmentIcon,
    title: "Unlock the Future of Interviewing With Interview Intelligence",
    description:
      "Get instant AI-powered transcripts, summaries, and scoring for Video Interviews - no more manual note-taking or second-guessing. ",
  },
  "dsr-develop-adopt-1": {
    icon: DSRDevelopUpgrade1Icon,
    title: `Don't Just Hire Great Talent. Develop It.`,
    description: `Love hiring with science and data? Use the same approach to empower your existing workforce with Develop.`,
  },
  "dsr-develop-adopt-2": {
    icon: DSRDevelopUpgrade2Icon,
    title: `Don't Just Hire Great Talent. Develop It.`,
    description:
      "Empower your managers to become superstars with 24/7, AI-based coaching and insights in Develop, custom-built for your team, and your team only.",
  },
};

export const DEVELOP_LANDING_PAGE_BASE_LINK =
  "https://assess.criteriacorp.com/develop/?";
export const SI_LANDING_PAGE_BASE_LINK =
  "https://interview.criteriacorp.com/structured-interviews/?";
